import React from "react";

import { Tabs, Tab, Modal, Button, ListGroup, ListGroupItem } from "react-bootstrap";
import moment from "moment";
import Select from "react-select";

import DatasetItem from "containers/View/Item/DatasetItem";
import DatasetColumnsContainer from "containers/Dataset/DatasetColumns";
import InteractionGraphContainer from "containers/Dataset/InteractionGraph";

import ClusterChartContainer from "containers/ClusterChart/ClusterChart";

import BlueprintViewContainer from "containers/View/Blueprint";

import AibleStep from "components/CreateWizard/AibleStep";

import styles from "./style.module.css";

import { isEnabled } from "utils/featureFlags";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

export default class Dataset extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { sectionKey: "create" };
  }

  render() {
    const {
      selection,
      dataset,
      datasetOptions,
      datasets,
      updateSelection,
      correlation,
      dataColumns,
      transform,
      success,
      id,
      match,
      step,
      isShow
    } = this.props;

    const { sectionKey } = this.state;

    return (
      <div className={styles.body}>
        <div className={styles.dataHeader}>
          <DatasetItem isTile id={dataset.id} />
          <AibleStep
            message={
              "This is dataset " +
              dataset.label +
              ", it was created on " +
              moment(dataset.created).format("MMMM Do YYYY") +
              " (" +
              moment(dataset.created).fromNow() +
              ") " +
              (dataset.created_by ? " by " + dataset.created_by.fullname : "")
            }
            secondaryMessage={
              "It contains " + Object.keys(dataset.fields).length + " columns, and " + dataset.rowCount + " rows."
            }
          />
        </div>
        <div className={styles.tabHolder}>
          <Tabs activeKey={sectionKey} onSelect={(key) => this.setState({ sectionKey: key })} id="dataTabs">
            <Tab title="Create" eventKey="create" />
            <Tab title="Details" eventKey="columns" />
            {isEnabled("clustering") && <Tab title="Cluster" eventKey="cluster" />}
            {isEnabled("clustering") && false && <Tab title="Interactions" eventKey="interactions" />}
          </Tabs>
        </div>
        <div className={styles.tabContent}>
          {sectionKey === "create" && (
            <div style={{ height: "100%" }}>
              <AibleStep message={"Select a blueprint below to apply to this dataset"} />
              <div style={{ height: "calc(100% - 120px)" }}>
                <BlueprintViewContainer hideCreateNew isSaveDataset={true} isTile height={"calc(100vh - 480px)"} />
              </div>
            </div>
          )}
          {sectionKey === "columns" && (
            <div style={{ paddingTop: "20px", paddingLeft: "10px", paddingRight: "10px" }}>
              <DatasetColumnsContainer id={dataset.id} />
            </div>
          )}
          {sectionKey === "cluster" && <ClusterChartContainer datasetId={dataset.id} fill />}
          {sectionKey === "interactions" && (
            <div className={styles.padContent}>
              <InteractionGraphContainer datasetId={dataset.id} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
